import { createAction, props } from '@ngrx/store';
import { CountryService } from '@wizbii/utils/models';

export const loadServicesSuccess = createAction(
  '[Services] Load services Success',
  props<{ service?: CountryService }>()
);
